import { useGetUnopenedNotificationsCount } from '@unifyapps/network/generated/notification-rest-api/notification-rest-api';
import { formatNumber } from '../../../utils/number';

type Return = ReturnType<typeof useGetUnopenedNotificationsCount> & {
  count: string | undefined;
};

export const useUnopenedNotificationsCount = (): Return => {
  const response = useGetUnopenedNotificationsCount();
  const { data } = response;

  return {
    ...response,
    count: data && data !== 0 ? formatNumber({ value: data, notation: 'compact' }) : undefined,
  };
};
